import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
export function FAQ() {
  const faqs = [{
    question: '¿De qué trata el libro?',
    answer: 'Rompiendo el Silencio es una guía compasiva y práctica para sobrevivientes de abuso infantil. Explora el proceso de sanación, ofreciendo herramientas para superar el trauma, establecer límites y recuperar el poder personal.'
  }, {
    question: '¿En qué formato está disponible?',
    answer: 'El libro está disponible en formato digital (Ebook) como PDF y EPUB, lo que te permite leerlo en cualquier dispositivo: teléfono, tablet, computadora o e-reader. También está disponible en formato físico (libro impreso) a través de Amazon, para quienes prefieren tenerlo en sus manos.'
  }, {
    question: '¿Cómo puedo comprar el libro?',
    answer: "Puedes adquirirlo directamente en esta página haciendo clic en el botón 'Comprar Ebook'. Aceptamos tarjetas de crédito, débito y PayPal a través de nuestra plataforma de pago seguro."
  }, {
    question: '¿El libro es autobiográfico?',
    answer: 'Aunque la autora comparte partes de su propia experiencia como sobreviviente para ilustrar ciertos puntos, el enfoque principal del libro es proporcionar una guía estructurada y herramientas de sanación para el lector.'
  }, {
    question: '¿Hay recursos adicionales?',
    answer: 'Sí, la compra del Ebook incluye acceso a hojas de trabajo descargables y ejercicios prácticos de reflexión que complementan cada capítulo del libro.'
  }, {
    question: '¿Cómo puedo contactar a la autora?',
    answer: 'Puedes utilizar el formulario de contacto en esta misma página. Daniela lee todos los mensajes, aunque debido al volumen, puede tomar algunos días en responder.'
  }];
  return <section className="bg-warm-beige py-24 px-6" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <AnimatedSection className="text-center mb-16" data-id="element-119">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-120">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-medium-brown" data-id="element-121">
            Resolvemos tus dudas sobre el libro y el proceso de compra.
          </p>
        </AnimatedSection>

        <AnimatedSection className="space-y-4" data-id="element-122">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-123" />)}
        </AnimatedSection>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-2xl shadow-sm border border-amber/10 overflow-hidden" data-id="element-124">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta/50" aria-expanded={isOpen} data-id="element-125">
        <span className="text-lg font-semibold text-deep-brown pr-4" data-id="element-126">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0 text-terracotta" data-id="element-127">
          <ChevronDown className="w-6 h-6" data-id="element-128" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-129">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-130">
            <div className="px-6 pb-5 text-medium-brown leading-relaxed" data-id="element-131">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}